import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import GalleriesIndex from './pages/Galleries/index';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Redirect base route to galleries for demonstration purposes */}
          <Route index element={<Navigate to="/galleries" replace />} />
          <Route path="galleries" element={<GalleriesIndex />} />
          {/* Removed the deeply nested /galleries/:slug route to simplify architecture */}
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;